import axios from 'axios'

// Use environment variable for API URL, fallback to relative path
// Vite exposes env variables through import.meta.env
const API_URL = (import.meta.env.VITE_API_URL as string | undefined) || '/api'

const api = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  withCredentials: true, // Important for cookies/sessions
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor for adding auth tokens if needed
api.interceptors.request.use(
  (config) => {
    // TODO: Add authentication token if needed
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // TODO: Handle unauthorized access
      console.error('Unauthorized access')
    }
    return Promise.reject(error)
  }
)

export default api

